import ApplicantAddressFactory from '@/common/services/Applicant/applicantAddressFactory'
import ApplicantBusinessFactory from '@/common/services/Applicant/ApplicantBusinessFactory'
import ApplicantEmailsFactory from '@/common/services/Applicant/applicantEmailsFactory'
import ApplicantFactory from '@/common/services/Applicant/applicantFactory'
import ApplicantPersonFactory from '@/common/services/Applicant/ApplicantPersonFactory'
import ApplicantPhoneFactory from '@/common/services/Applicant/applicantPhoneFactory'
import WorkspaceFactory from '@/common/services/Workspace/WorkspaceFactory'
import WORKFLOW_TYPES from '@/common/enums/workflowTypesEnum'
import {injectable, inject} from 'inversify'
import {SingletonService} from '@/common/dependency.configs'
@SingletonService
@injectable()
class SummaryFactory {
  constructor(
    @inject(ApplicantBusinessFactory)
    private applicantBusinessFactory: ApplicantBusinessFactory,
    @inject(ApplicantAddressFactory)
    private applicantAddressFactory: ApplicantAddressFactory,
    @inject(ApplicantEmailsFactory)
    private applicantEmailsFactory: ApplicantEmailsFactory,
    @inject(ApplicantPersonFactory)
    private applicantPersonFactory: ApplicantPersonFactory,
    @inject(ApplicantPhoneFactory)
    private applicantPhoneFactory: ApplicantPhoneFactory,
    @inject(WorkspaceFactory)
    private workspaceFactory: WorkspaceFactory,
    @inject(ApplicantFactory)
    private applicantFactory: ApplicantFactory
  ) {}
  getWorkspaceSummary(workspaceUUID: string) {
    return this.workspaceFactory
      .getWorkspace(workspaceUUID)
      .then((workspace) => {
        const activeApplicants = (workspace.applicants ?? []).filter(
          (a) => a.applicantStatus !== 'DELETED'
        )
        const activeEnrollments = (workspace.enrollments ?? []).filter(
          (e) => e.enrollmentStatus !== 'DELETED'
        )
        return this.applicantFactory
          .setApplicantListInfo(workspaceUUID, activeApplicants)
          .then((enrichedApplicants) => {
            workspace.applicants = enrichedApplicants
            workspace.enrollments = activeEnrollments
            return workspace
          })
      })
  }
  getApplicantSummary(workspaceUUID: string, applicantId: number) {
    return this.applicantFactory
      .get(workspaceUUID, applicantId)
      .then((applicant) => {
        return Promise.all([
          Promise.resolve(applicant),
          this.applicantAddressFactory.getAll(workspaceUUID, applicantId),
          this.applicantPhoneFactory.getApplicantPhoneList(workspaceUUID, applicantId),
          this.applicantEmailsFactory.getApplicantEmailList(workspaceUUID, applicantId),
          applicant.applicantType === WORKFLOW_TYPES.PERSON
            ? this.applicantPersonFactory.get(workspaceUUID, applicantId)
            : this.applicantBusinessFactory.get(workspaceUUID, applicantId)
        ])
      })
      .then((applicantSummary) => {
        const applicant = applicantSummary[0]
        applicant.addresses = applicantSummary[1]
        applicant.phones = applicantSummary[2]
        applicant.emails = applicantSummary[3]
        if (applicant.applicantType === WORKFLOW_TYPES.BUSINESS) {
          applicant.business = applicantSummary[4]
        } else {
          applicant.person = applicantSummary[4]
        }
        return applicant
      })
  }
}
export default SummaryFactory
